import { Component, Input, OnDestroy } from '@angular/core';
import { ApplicationQuery } from '@app/store/application/application.query';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'qe-breadcrumbs-step',
	templateUrl: './breadcrumbs-step.component.html',
	styleUrls: ['./breadcrumbs-step.component.scss'],
})
export class BreadcrumbsStepComponent implements OnDestroy {
	@Input() step!: number;
	private readonly ngUnsubscribe$: Subject<boolean> = new Subject();
	// eslint-disable-next-line
	private currentStep!: number;
	public get isActive(): boolean {
		return this.currentStep === this.step;
	}
	public get isCompleted(): boolean {
		return this.currentStep > this.step;
	}

	constructor(private readonly appQueries: ApplicationQuery) {
		this.appQueries
			.wofklowStep$()
			.pipe(takeUntil(this.ngUnsubscribe$))
			.subscribe(step => this.currentStep = step);
	}

	ngOnDestroy(): void {
		this.ngUnsubscribe$.next(true);
		this.ngUnsubscribe$.unsubscribe();
	}

}
